<template>
  <footer>
    <div class="footer-navItem v-container">
      <div class="navs-box">
          <el-row :gutter="20" style="width: 100%;">
            <el-col :xl="6" :lg="6" :md="12">
              <div class="logo">
                <h1>
                  <img :src="logoUrl" :alt="appName">
                </h1>
              </div>
            </el-col>
            <el-col :xl="6" :lg="6" :md="12" v-for="(navItem, i) in navs" :key="i" class="navs-box-item">
              <h3 class="navs-title">{{ navItem.title }}</h3>
              <div class="navs-item-box">
                  <div
                  v-for="(pathRouter, i) in navItem.routes"
                  :key="`${i}_${pathRouter}`"
                  @click="handleRouter(pathRouter.path)"
                  class="navs-item"
                  >
                  <span>{{ pathRouter.pathName }}</span>
                  </div>
              </div>
            </el-col>
            <el-col :xl="6" :lg="6" :md="12" class="navs-box-item">
              <h3 class="navs-title">{{ $t('1127') }}</h3>
                <div class="btn flex-nw">
                <a href="#" class="d-btn" @click="goToDownload">
                    <!-- <img src="@/assets/img/down_ios_active.png" alt="" /> -->
                    <span>IOS {{$t('1127')}}</span>
                </a>
                <a href="#" class="d-btn" @click="goToDownload">
                  <span>Android {{$t('1127')}}</span>
                    <!-- <img src="@/assets/img/down_android.png" alt="" /> -->
                </a>
                <a href="#" class="d-btn" @click="goToH5">
                  <span class="active">H5 {{$t('1128')}}</span>
                    <!-- <img src="@/assets/img/down_h5.png" alt="" /> -->
                </a>
                </div>
            </el-col>
          </el-row>
      </div>
    </div>
    <div class="footer-copyright">
      <p class="col-12 copyright">
        COPYRIGHT © 2017-2026 <span>{{appName}}</span>. ALL RIGHTS RESERVED.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      navs: [
        {
          title: this.$t("nav5"),
          routes: [
            {
              path: "about",
              pathName: this.$t("nav6"),
            },
            {
              path: "about",
              pathName: this.$t("nav7"),
            },
            {
              path: "about",
              pathName: this.$t("nav8"),
            },
            {
              path: "about",
              pathName: this.$t("nav9"),
            },
          ],
        },
        {
          title: this.$t("nav14"),
          routes: [
            {
              path: "about",
              pathName: this.$t("nav10"),
            },
            {
              path: "about",
              pathName: this.$t("nav11"),
            },
            {
              path: "about",
              pathName: this.$t("nav12"),
            },
            {
              path: "about",
              pathName: this.$t("nav13"),
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleRouter(path) {
      this.$router.push(path);
    },
    goToDownload() {
      window.location.href = window.configObj.downloadUrl;
    },
    goToH5() {
      window.location.href = location.origin + "/h5/";
    }
  },
  computed:{
    logoUrl() {
      return window.configObj.logoUri
    },
    appName() {
      return window.configObj.appName
    }
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  bottom: 0;
  text-align: center;
  background: #FDFAF6;
  //  height: 182px;
  color: #fff;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;
  //  padding: 10px;
  .footer-navItem {
    width: 100%;
    .navs-box {
      display: inline-flex;
      margin: 60px 0;
    //   flex-wrap: wrap;
      width: 100%;
      justify-content: space-between;
      padding-bottom: 40px;
      .logo {
        //  width: 100%;
        position: relative;
        font-size: 25px;
        text-align: left;
        color: #00b5ac;
        margin: 30px 0 60px 0;
        img {
          width: 168px;
          height: 168px;
        }
      }
      .navs-box-item {
        text-align: left;

        .navs-title {
          margin: 20px auto;
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 600;
          font-size: 24px;
          color: #5D2146;
        }
        .navs-item-box {
          padding-top: 20px;
          .navs-item {
            margin: 10px 20px 10px 0px;
            cursor: pointer;
            span {
              font-family: 'PingFang SC';
              font-style: normal;
              font-weight: 400;
              color:  #91929E;;
              font-size: 20px;
            }
            i{margin-right: 8px; color: #0088ff;}
          }
        }
        .flex-nw{
          display: flex;
          flex-direction: column;
          font-family: 'Arial';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          color: #C21DD0;
          align-items: flex-start;
          .d-btn{
          margin-top: 20px;
           span{
            display: inline-block;
            width: 190px;
            height: 64px;
            border: 1px solid #E01697;
            text-align: center;
            line-height: 64px;
            border-radius: 17px;
            &.active,&:hover {
                background: linear-gradient(90deg, #E01697 0%, #C01ED5 100%);
                box-shadow: 0px 26px 24px -15px rgba(193, 30, 211, 0.502177);
                color: #fff;
              }
          }
        }
        }
      }
    }
    .des-long {
      font-size: 8px;
      margin-bottom: 50px;
      color: #999;
      p {
        text-align: left;
      }
    }
    .copyright {
      margin-bottom: 50px;
      height: 80px;
      color: #999;
    }
  }
  .footer-copyright {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    .des-long-bg {
      width: 100%;
      background: #222;
      display: flex;
      justify-content: center;
      padding: 50px 20px;
      .des-long {
        color: #999;
        max-width: 1100px;
        text-align: left;
      }
    }
    .copyright {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 80px;
      color: #5B5C5E;
    }
  }
}
@media (max-width: 1200px) {
footer .footer-navItem {
    padding: 0 10px;
.navs-box{
    flex-wrap: wrap;
    justify-content: center;
    .logo{
      text-align: center;
    }
    .navs-box-item {
        margin: 10px 0;
        text-align: center;
        .navs-title {
        margin: 0 auto;
        width: 38vw;
        }
        .navs-title::before {
            display: none;
        }
        .navs-item-box {
             justify-content: space-between;
            .navs-item{
                margin: 10px 3px;
            }
        }
        .flex-nw{
          align-items: center;
        }
      }
    }
}
  footer .footer-navItem .logo {
    margin-top: 100px;
  }
  footer .footer-copyright .copyright {
    line-height: 18px;
    padding: 30px 10px;
  }
}
</style>
